import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  CancelComponent,
  FeedbackSurveyComponent,
  LayoutDefaultComponent,
} from '@shared/components';
import { ButtonModule } from '@vg-constellation/angular-16/button';
import { LinkModule } from '@vg-constellation/angular-16/link';
import {
  MfeLoadModule,
  VgimCommonModule,
  VgimDAOfferModule,
  VgimInvestmentOptionsModule,
  VgimRetirementAgeModule,
  VgimTaxesModule,
} from 'vg-interaction-model/dist';

import { DAEnrollComponent } from './da-enroll/da-enroll.component';
import { DAOfferComponent } from './da-offer/da-offer.component';
import { InvestmentStrategyComponent } from './investment-strategy/investment-strategy.component';
import { MultiAccountEnrollmentComponent } from './multi-account-enrollment/multi-account-enrollment.component';
import { PortfolioMatchComponent } from './portfolio-match/portfolio-match.component';
import { RiskQuizResultsComponent } from './risk-quiz-results/risk-quiz-results.component';
import { RiskQuizSetupComponent } from './risk-quiz-setup/risk-quiz-setup.component';
import { TaxFilingRetirementComponent } from './tax-filing-retirement/tax-filing-retirement.component';

@NgModule({
  declarations: [
    TaxFilingRetirementComponent,
    DAOfferComponent,
    InvestmentStrategyComponent,
    MultiAccountEnrollmentComponent,
    PortfolioMatchComponent,
    RiskQuizResultsComponent,
    RiskQuizSetupComponent,
    DAEnrollComponent,
  ],
  imports: [
    CancelComponent,
    CommonModule,
    ButtonModule,
    LinkModule,
    CancelComponent,
    FeedbackSurveyComponent,
    LayoutDefaultComponent,
    VgimCommonModule.forRoot({
      environment: 'production',
      application: 'COO',
    }),
    VgimDAOfferModule,
    VgimRetirementAgeModule,
    VgimTaxesModule,
    VgimInvestmentOptionsModule,
    MfeLoadModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OpenChoiceModule {}
